import { createContext } from "react";

export type AddMessage = (message: React.ReactNode, type: "success" | "failure") => void;

export type FlashMessageContextValue = {
  addMessage: AddMessage;
};
const FlashMessageContext: React.Context<FlashMessageContextValue> =
  createContext<FlashMessageContextValue>({
    addMessage: () => undefined
  });

export default FlashMessageContext;
